export const SET_USER = "SET_USER";
export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const SET_LAST_NAME = "SET_LAST_NAME";